/**
 * Sentinel stored in a section's `totalValueField` to mean "show no total in the
 * sub-period summary header" — distinct from `undefined`, which falls back to the
 * reward's own value field. Not a real dataset field, so it never collides.
 */
export const HIDE_HEADER_TOTAL = '__none__';

/**
 * Resolves which dataset field a sub-period summary total should sum/format:
 * - `HIDE_HEADER_TOTAL` → `undefined` (hide the total)
 * - an explicit field → that field
 * - `undefined` → the fallback (the reward's own value field)
 */
const resolveHeaderTotalField = ({
  totalValueField,
  fallbackField,
}: {
  totalValueField: string | undefined;
  fallbackField: string | undefined;
}): string | undefined => {
  if (totalValueField === HIDE_HEADER_TOTAL) {
    return undefined;
  }
  return totalValueField ?? fallbackField;
};

export default resolveHeaderTotalField;
